<template>
  <div v-if="initialized" id="app"
       :class="{ 'ziggu_sm': isMobile || isTablet, 'ziggu_lg': isDesktop,
                 'environment-staging-border': environment === VITE_ENV_STAGING,
                 'environment-development-border': environment === VITE_ENV_DEVELOPMENT,
                 'environment-review-border': environment === VITE_ENV_REVIEW }">
    <NavbarDesktopSupervisor v-if="isDesktop"/>
    <NavbarTabletSupervisor v-else/>
    <TopbarDesktop v-if="isDesktop"/>
    <TopbarTablet v-else/>
    <main id="page" :class="{'sidebar-padding': isDesktopWide && sidebar_type }">
      <div id="container" :class="{ 'section container is-widescreen': !is_dashboard_page }">
        <router-view/>
      </div>
    </main>
  </div>
</template>

<script>
import NavbarDesktopSupervisor from '@/app/_supervisors/components/navbar/TheNavbarDesktopSupervisor.vue';
import NavbarTabletSupervisor from '@/app/_supervisors/components/navbar/TheNavbarTabletSupervisor.vue';
import TopbarDesktop from '@/app/shared_components/navbar/TheTopbarDesktop.vue';
import { ROUTES_SUPERVISORS } from '@/app/data/route_constants';
import profile_mixin from '@/app/util/profile_mixin';
import TopbarTablet from '../shared_components/navbar/TheTopbarTablet.vue';

export default {
  name: 'Supervisor',
  components: {
    NavbarDesktopSupervisor,
    NavbarTabletSupervisor,
    TopbarDesktop,
    TopbarTablet,
  },
  mixins: [profile_mixin],

  data() {
    return {
      ROUTES_SUPERVISORS,
    };
  },

  computed: {
    is_dashboard_page() {
      return this.$route.name.startsWith(ROUTES_SUPERVISORS.DASHBOARD);
    },
  },

  async created() {
    await this.initProfile();
  },
};

</script>
